import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { ButtonCancelDialogComponent } from '@component/button-cancel-dialog/button-cancel-dialog.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CrearMenuComponent } from '../crear-menu.component';

@Component({
  standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, CommonModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, AppRolesDirective, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatIconModule, ButtonCancelDialogComponent,
      NgxSpinnerModule,CrearMenuComponent],
  selector: 'app-dialog-create-menu',
  templateUrl: './dialog-create-menu.component.html',
  styleUrls: ['./dialog-create-menu.component.css']
})
export class DialogCreateMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
